import React, { useState, useEffect } from 'react';
import './App.css';
import Footer from './Components/Footer';
import CartSection from './Components/CartSection';
import CartBox from './Components/CartBox';
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { CartProvider } from './CartContext';
import { SearchProvider } from './SearchContext';
import Orders from './Components/Orders';
import Home from './pages/Home';
import Product from './pages/Product';
import { Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import PopupInfo from './Components/PopupInfo';
import Login from "./Components/login";
import OrderDetail from "./Components/OrderDetail";
import ProductDetail from "./pages/Product/productDetail";

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

function App() {
  const [cart, setCart] = useState(() => {
    const storedCart = localStorage.getItem("cartValue");
    return storedCart ? JSON.parse(storedCart) : [];
  });

  const [cartVisible, setCartVisible] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [pageVisible, setPageVisible] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [showPopup, setShowPopup] = useState(true);
  const [showPlacedOrderSummary, setShowPlacedOrderSummary] = useState(false);

  const [form, setForm] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    address: '',
    tableNo: '',
  });

  const location = useLocation();

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("cartValue", JSON.stringify(cart));
  }, [cart]);

  // Detect ?table= query param and set visibility
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tableNo = queryParams.get('table');
    if (tableNo) {
      setForm((prev) => ({ ...prev, tableNo }));
      setShowPopup(true);
      setPageVisible(true);
    } else {
      setShowPopup(false);
      setPageVisible(false);
    }
  }, [location]);

  // Add item to cart
  const handleClick = (menuItem) => {
    const isDuplicate = cart.some(
      (item) => item._id === menuItem._id && item.name === menuItem.name
    );
    if (!isDuplicate) {
      const newCart = [...cart, menuItem];
      setCart(newCart);
      localStorage.setItem("cartValue", JSON.stringify(newCart));
    } else {
      enqueueSnackbar('Item already Added', { variant: 'error' });
    }
  };

  const handleCartClick = () => {
    setCartVisible(!cartVisible);
  };

  // Hide Navbar/Footer on specific routes
  const hideLayout =
    location.pathname === "/login" ||
    location.pathname === "/orders/orderview";

  return (
    <SnackbarProvider>
      <CartProvider>
        <SearchProvider>
          <>
            {/* Top cart section */}
            {!hideLayout && (
              <CartSection
                size={cart.length}
                handleCartClick={handleCartClick}
                cartVisible={cartVisible}
                phoneNumber={phoneNumber}
                setloggedIn={setLoggedIn}
                setPhoneNumber={setPhoneNumber}
                pageVisible={pageVisible}
                setCartVisible={setCartVisible}
                setPageVisible={setPageVisible}
                form={form}
                setForm={setForm}
                loggedIn={loggedIn}
                setLoggedIn={setLoggedIn}
                setShowPlacedOrderSummary={setShowPlacedOrderSummary}
              />
            )}

            {/*  Floating cart box */}
            {!hideLayout && (
              <CartBox
                cart={cart}
                setCart={setCart}
                size={cart.length}
                cartVisible={cartVisible}
                setCartVisible={setCartVisible}
                handleCartClick={handleCartClick}
                phoneNumber={phoneNumber}
                setPageVisible={setPageVisible}
                pageVisible={pageVisible}
                form={form}
                setForm={setForm}
                loggedIn={loggedIn}
              />
            )}

            {/*  App Routes */}
            <Routes>

              <Route
                path="/"
                element={
                  <>
                    {showPopup && <PopupInfo setShowPopup={setShowPopup} />}
                    <Home
                      handleClick={handleClick}
                      handleCartClick={handleCartClick}
                      cart={cart}
                      pageVisible={pageVisible}
                    />
                  </>
                }
              />

              {/*  Product Category */}
              <Route
                path="/products/:id"
                element={
                  <Product
                    handleClick={handleClick}
                    handleCartClick={handleCartClick}
                    cart={cart}
                    setCart={setCart}
                    setCartVisible={setCartVisible}
                  />
                }
              />

              {/*  Login */}
              <Route path="/login" element={<Login />} />

              {/*  My Orders Page (NEW) */}
              <Route path="/orders" element={<Orders />} />

              {/*  Order Detail */}
              <Route path="/orders/orderview" element={<OrderDetail />} />

              {/*  Product Detail */}
              <Route
                path="/product/:id"
                element={
                  <ProductDetail
                    handleClick={handleClick}
                    cart={cart}
                    setCart={setCart}
                  />
                }
              />
            </Routes>

            {/*  Footer (hidden on login/order detail) */}
            {!hideLayout && (
              <Footer size={cart.length} setCartVisible={setCartVisible} />
            )}
          </>
        </SearchProvider>
      </CartProvider>
    </SnackbarProvider>
  );
}

export default App;
